<template lang="pug">
  .container
    h4
      span.muted {{ $t('Gonna upgrade and replace extension: ') }}
      span {{ `${extensionUpgraded.Network ? 'local' : 'global'} ${extensionUpgraded.name} v.${extensionUpgraded.version}` }}
    hr.header
    .table-title {{ $t('Extensions that can be used for upgrade:') }}
    .row.table-header.muted
      .cell.name {{ $t('Name') }}
      .cell.version {{ $t('Version') }}
      .cell.networks {{ $t('# Networks using') }}
      .cell.global
        span {{ $t('Local') }}
        font-awesome-icon(icon="wifi")
        span &nbsp; | &nbsp;
        span {{ $t('Global') }}
        font-awesome-icon(icon="globe")
    .row.other-extension(
      v-for='otherExtension in otherExtensions',
      :key='otherExtension.id',
      :id="'UpgradeExtension-otherExtensionRow' + otherExtension.id"
      @click='toggleSelectedOtherExtension(otherExtension)',
      :class="{ selected: (selectedOtherExtension.id === otherExtension.id) }"
    )
      .cell.name {{ otherExtension.name }}
      .cell.version {{ otherExtension.version }}
      .cell.networks {{ otherExtension.Files.length > 0 ? otherExtension.Files.length : '-' }}
      .cell.global
        .section(v-if='otherExtension.Network')
          font-awesome-icon(icon="wifi")
          span &nbsp; {{ otherExtension.Network.name }}
        .section(v-else)
          font-awesome-icon(icon="globe")
    .row.float-right(v-if='selectedOtherExtension.id')
      el-button(id="UpgradeExtension-replaceInNetworkButton" type="success", size="mini", @click='onlyInCurrentNetwork = true; openConfirmDialog()')
        span {{ $t('Replace extension in current network ') }}
        font-awesome-icon(icon="retweet")
        span &nbsp;
        font-awesome-icon(icon="wifi")
      el-button(id="UpgradeExtension-replaceInSystemButton" v-if='!selectedOtherExtension.Network', type="success", size="mini", @click='onlyInCurrentNetwork = false; openConfirmDialog()')
        span {{ $t('Replace extension system-wide ') }}
        font-awesome-icon(icon="retweet")
        span &nbsp;
        font-awesome-icon(icon="globe")
      ConfirmDialog(
        v-if='confirmDialogVisible',
        :confirmDialogVisible='confirmDialogVisible',
        :question='confirmDialogQuestion',
        @confirmed='dialogConfirmed()',
        @closed='dialogDenied()'
      )
    .row.warning(v-if='selectedOtherExtension.configSchema && (JSON.stringify(extensionUpgraded.configSchema) !== JSON.stringify(selectedOtherExtension.configSchema))')
      span {{ $t('Schema is different. All configurations of existing media will be reset to default values for new extension.') }}
</template>

<script>

import Vue from 'vue'
import ConfirmDialog from '../Common/ConfirmDialog'

export default {
  props: ['upgradedExtensionMediumId'],
  components: {
    ConfirmDialog
  },
  async created () {
    this.medium = this.$store.state.Medium.media_list.find(m => m.id === this.upgradedExtensionMediumId)
    await this.getExtension()
    await this.getExtensionsList()
  },
  updated () {
  },
  watch: {
    watched: function (newVal, oldVal) {
    }
  },
  data () {
    return {
      medium: {},
      extensionUpgraded: {},
      extensionsList: [],
      selectedOtherExtension: {},
      confirmDialogVisible: false,
      confirmDialogQuestion: '',
      onlyInCurrentNetwork: false
    }
  },
  methods: {
    openConfirmDialog () {
      this.confirmDialogQuestion = this.$t(`Are you sure you want to replace
       (${this.onlyInCurrentNetwork ? 'in current network' : 'in all networks'})
       ${this.extensionUpgraded.name} v.${this.extensionUpgraded.version}
       with ${this.selectedOtherExtension.name} v.${this.selectedOtherExtension.version}?`)
      this.confirmDialogVisible = true
    },
    async dialogConfirmed () {
      // console.error('extensionUpgraded', this.extensionUpgraded.id)
      // console.error('selectedOtherExtension', this.selectedOtherExtension.id)
      // console.error('onlyInCurrentNetwork', this.onlyInCurrentNetwork)
      await Vue.axios.post(`extension/upgradeExtension`,
        {
          extensionUpgradedId: this.extensionUpgraded.id,
          selectedOtherExtensionId: this.selectedOtherExtension.id,
          onlyInCurrentNetwork: this.onlyInCurrentNetwork
        }
      )
        .then(response => {
          this.$emit('finished')
        })
      this.confirmDialogVisible = false
    },
    dialogDenied () {
      this.confirmDialogVisible = false
    },
    toggleSelectedOtherExtension (extension) {
      this.selectedOtherExtension.id === extension.id ? this.selectedOtherExtension = {} : this.selectedOtherExtension = extension
    },
    async getExtension () {
      if (!this.medium.File.Extension) {
        this.medium = await this.$store.dispatch('Medium/getMedium', {
          data: this.medium.id,
          options: { populate: true }
        })
      }
      await Vue.axios.get(`extension/${this.medium.File.Extension}`)
        .then(response => {
          this.extensionUpgraded = response.data
        })
    },
    async getExtensionsList () {
      await Vue.axios.get(`extension/`)
        .then(response => {
          this.extensionsList = response.data
        })
    }
  },
  computed: {
    otherExtensions () {
      return this.extensionsList
        .filter(ext => ext.filename !== this.extensionUpgraded.filename)
        .filter(ext => !ext.Network || (this.$store.state.User.user.lastNetworkId === ext.Network.id))
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.table-title {
  margin-top: 50px;
}
.row {
  padding: 10px 5px;
  .cell {
    min-width: 20%;
    width: calc(100%/3);
  }
  &.selected {
    background-color: $--background-color-selected;
  }
  &.table-header {
    border-bottom: $--border-light;
  }
  &.other-extension {
    border-bottom: $--border-light;
  }
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/UpgradeExtension.vue